import(/* webpackMode: "eager" */ "/app/dashboard/app/dashboard/page.tsx");
